// KeyBenefits.js
import React from "react";
import "./KeyBenefits.css";
import buildingImage from "./HeroSection/assets/building.jpg";
import AnimatedSection from "./AnimatedSection";
import {
  FaBookOpen,
  FaUserGraduate,
  FaUserTie,
  FaChalkboardTeacher,
  FaHandshake,
  FaUsers,
} from "react-icons/fa";

const KeyBenefits = () => {
  const benefits = [
    {
      icon: <FaBookOpen />,
      title: "Learn What Matters",
      desc: "Get access to real world skills from people who've done it before not just theory, but actionable, practical knowledge.",
    },
    {
      icon: <FaUserGraduate />,
      title: "Learn from Skillfluencers",
      desc: "Skillfluencers bring you hands on knowledge, real world experience, and fresh insights across industries.",
    },
    {
      icon: <FaUserTie />,
      title: "Become a Skillfluencer",
      desc: "Got expertise? Turn your skills into influence. Teach, inspire, and monetize your knowledge while building your personal brand.",
    },
    {
      icon: <FaChalkboardTeacher />,
      title: "Teach and Earn",
      desc: "Turn your expertise into income by mentoring others. Set your own rates, your own schedule, and grow your reputation.",
    },
    {
      icon: <FaHandshake />,
      title: "Skill Meets Opportunity",
      desc: "Whether you're upskilling, cross skilling, or looking to monetize what you already know  this is your launchpad.",
    },
    {
      icon: <FaUsers />,
      title: "Connect and Grow",
      desc: "Whether you're here to upskill, explore new paths, or showcase what you know  you're in the right place.",
    },
  ];

  const points = [
    {
      point:
        "Learn from real people doing real things no fluff, just useful skills.",
    },
    {
      point:
        "Share what you know and get paid for it expert others, grow your brand.",
    },
    { point: "Connect with doers and learners who are as driven as you are." },
  ];

  return (
    <div>
      {/* SECTION 1: Side-by-side layout */}
      <div>
        <section className="why-section">
          {/* Right: Text content */}
          <div className="desktop-why ellipse-container">
            <h2>Why join Upskillmeet?</h2>
            <h4>
              Because skills fuel success and we've built the
              launchpad.Upskillmeet is a dynamic skill marketplace where
              learners, experts, and professionals come together to learn, earn,
              share, and grow through real world skills that matter.At
              Upskillmeet, you can:
            </h4>
            <ul>
              <li>
                Learn from real people doing real things no fluff, just useful
                skills.
              </li>
              <li>
                Share what you know and get paid for it expert others, grow your
                brand.
              </li>
              <li>
                Connect with doers and learners who are as driven as you are.
              </li>
            </ul>
            <p className="why-choose-text-footer">
              Whether you're starting out, switching paths, or leveling up
              Upskillmeet is your space to grow.
            </p>
          </div>
          {/* Mobile‑only layout */}
          <div className="mobile-why">
            <div className="why-section-card">
              <h2>Why join Upskillmeet?</h2>
              <h4>
                Because skills fuel success and we've built the launchpad.
                Upskillmeet is a dynamic skill marketplace where learners,
                experts, and professionals come together to learn, earn, share,
                and grow through real-world skills that matter. At Upskillmeet,
                you can:
              </h4>
              <ul>
                <li>
                  Learn from real people doing real things no fluff, just useful
                  skills.
                </li>
                <li>
                  Share what you know and get paid for it expert others, grow
                  your brand.
                </li>
                <li>
                  Connect with doers and learners who are as driven as you are.
                </li>
              </ul>
              <p className="why-choose-text-footer">
                Whether you're starting out, switching paths, or leveling up
                Upskillmeet is your space to grow.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* SECTION 2: Benefit Cards - also optionally animate */}
      <div>
        <section className="benefits-section">
          <h2 className="benefits-heading">Explore Our Key Benefits</h2>
          <div className="benefits-grid">
            {benefits.map((item, index) => (
              <div key={index} className="benefit-card">
                <span className="benefit-icon">{item.icon}</span>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default KeyBenefits;
